export default {
  main: '#EDEAE6',
  secondary: '#000000',
  contrastingColor: '#000000',
  priceColor: '#002855',
  entryBackground: '#EDEAE6',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
